"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.KeyboardAvoidingView = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native");
var _useKeyboard2 = require("../../hooks/useKeyboard");
var _jsxFileName = "/home/circleci/wellth/packages/ui/src/components/KeyboardAvoidingView/index.tsx";
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        "default": e
      };
    if (null === e || "object" != _typeof(e) && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]);
    return f;
  })(e, t);
}
var animateTo = function animateTo(animation, toValue, duration) {
  _reactNative.Animated.timing(animation, {
    toValue: toValue,
    duration: duration,
    useNativeDriver: false
  }).start();
};
var KeyboardAvoidingView = exports.KeyboardAvoidingView = function KeyboardAvoidingView(_ref) {
  var _ref$offset = _ref.offset,
    offset = _ref$offset === void 0 ? 0 : _ref$offset,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? null : _ref$style,
    children = _ref.children;
  var heightAnimation = (0, _react.useRef)(new _reactNative.Animated.Value(0)).current;
  var _useKeyboard = (0, _useKeyboard2.useKeyboard)(),
    _useKeyboard$animatio = _useKeyboard.animation,
    duration = _useKeyboard$animatio.duration,
    isActive = _useKeyboard$animatio.active,
    type = _useKeyboard$animatio.type,
    end = _useKeyboard.coordinates.end;
  (0, _react.useEffect)(function () {
    if (isActive) {
      var toValue = type === "show" ? end.height : 0;
      animateTo(heightAnimation, toValue + offset, duration);
    }
  }, [end, duration, isActive, heightAnimation, type, offset]);
  return _react["default"].createElement(_react["default"].Fragment, null, children, _react["default"].createElement(_reactNative.Animated.View, {
    style: [style, {
      height: heightAnimation
    }],
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 7
    }
  }));
};
var _default = exports["default"] = KeyboardAvoidingView;